import {AuthenticationService} from '../_services';
import {HttpClient} from "@angular/common/http";

export class LoginHelper {

    constructor(public http: HttpClient,
        public authenticationService: AuthenticationService) { }

  //TOTO : Migration
    /*public static jwt() {
        // create authorization header with jwt token
        let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        if (currentUser && currentUser.token) {
            let headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
            return new RequestOptions({ headers: headers });
        }
    }*/

    public static getTenantName(): string {
        // create authorization header with jwt token
        let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        if (currentUser != null) {
            return currentUser.tenantName;
            }

        return null;
    }

    public static getTenantNameFromUrl(): string {
      let tenantName = null;
      let hostname = location.hostname;

      const urlParams = new URLSearchParams(window.location.search);
      const tenantParam = urlParams.get('tenant');
      if (tenantParam) return tenantParam;

      const regexp = new RegExp((<any>window).tenantHostnameTemplate.replace('{0}', '(.*)'), 'ig');
      const arr = regexp.exec(hostname);
      if (arr != null && arr.length > 1 && arr[1].toLowerCase() != 'app') {
        tenantName = arr[1];
      }

      return tenantName;
    }

  public static getUserId(): string {
        // create authorization header with jwt token
        let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        if (currentUser != null) {
            return currentUser.userId;
            }

        return null;
    }

  public static getUserToken(): string {
    // create authorization header with jwt token
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    if (currentUser != null) {
      return currentUser.token;
    }

    return null;
  }

  public static getFileToken(): string {
    // create authorization header with jwt token
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    if (currentUser != null) {
      return encodeURIComponent(currentUser.fileAccessKey);
    }

    return null;
  }

  public static addJwt(requestOptions: any) {
        // create authorization header with jwt token
        let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        if (currentUser && currentUser.token) {

            //console.log(requestOptions);

            requestOptions.headers = new Headers({'Authorization': 'Bearer ' + currentUser.token });
        }

        return requestOptions;
    }
}
